import { Component } from '@angular/core';

@Component({
  selector: 'app-header-userbox',
  templateUrl: './header-userbox.component.html'
})
export class HeaderUserboxComponent {
    user: any;
  constructor() {
    this.user = JSON.parse(localStorage.getItem('user'));
  }
}
